
/**
 * Data-driven UI logic that displays the source label and link if it exists in the single record details page
 *
 * Created by ipatrikeeva on 11/27/2017
 */



/**
 * Construct a top-level source object from data UI model
 * @param item {object} - JavaScript object of the record title row
 * @returns {object}
 */
function getSourceObject( item ) {
    var result = {},
        model;

    if ( item ) {
        // Retrieve cached UI model
        if ( GlobalPageState && GlobalPageState.type ) {
            model = getDataModel( GlobalPageState.type, false );
            if ( model ) {
                result = getModelProperty(model, "source");
            }
        }
    }

    return result;
}